import axios from 'axios'
import { MessageBox, Message, Loading } from 'element-ui'

let loadingCount = 0
let loading

function startLoading() {
  if (loadingCount === 0) {
    loading = Loading.service({
      lock: true,
      text: '进行中……',
      background: 'rgba(0, 0, 0, 0.7)'
    })
  }
  loadingCount++
}

function stopLoading() {
  loadingCount--
  if (loadingCount === 0) {
    loading.close()
  }
}

export function request(config) {
  const instance = axios.create({
    baseURL: '',
    withCredentials: true,
    timeout: 10000
  })
  // request interceptor
  instance.interceptors.request.use(
    config => {
      startLoading()
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  // response interceptor
  instance.interceptors.response.use(
    res => {
      stopLoading()
      const data = res.data
      if (data.status === '200') {
        return data
      } else {
        console.log('后端返回异常：' + data)
        Message({
          message: data.message || '请求出现异常',
          type: 'error',
          customClass:'global-messageZindex'
        })
        // return Promise.reject(data)
      }
    },
    error => {
      stopLoading()
      console.log('err' + error) // for debug
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000,
        customClass:'global-messageZindex'
      })
      return Promise.reject(error)
    }
  )
  return instance(config)
}
